import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { NativeSelect, Container as SelectInput } from '../inputs/SelectInput.style';
import { Label } from '../inputs/TextInput.style';
import { MidHeading } from '../typography';

export const Container = styled.div`
  background: ${(props) => props.theme.primary};
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 460px;

  @media (${laptopMediumMax}) {
    padding: 20px;
    ${MidHeading} {
      margin-bottom: 20px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  gap: 30px;

  ${NativeSelect} {
    -webkit-appearance: none;
  }

  ${Label} {
    color: ${({ theme }) => theme.white};
  }

  @media (${laptopMediumMax}) {
    gap: 15px;
  }

  @media (${mobileXXLargeMax}) {
    ${SelectInput}:not(:first-child) {
      margin-top: 0;
      margin-left: 0;
    }
  }
`;
